export const getSendVerificationCodeUrl = () => '/send_code';
export const getVerificationCodeUrl = () => '/verify_code';
export const getLogoutUrl = () => '/logout';
export const getRequestVerificationCodeForCSUrl = () => '/send_code_for_cs';
export const generateSSOTokenUrl = () => '/generate_sso_token';
export const getNetsapiensLoginUrl = () => '/netsapiens_login';
